<template>
	<div class="helpDetails">
		<div class="wrap-container">
			<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/aboutIntroduce' }">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/aboutUs' }">帮助中心</el-breadcrumb-item>
				<el-breadcrumb-item>{{ title }}详情</el-breadcrumb-item>
			</el-breadcrumb>

			<div class="search-box">
				<div class="search-box-nav">
					<div class="box-nav-title">{{ notic.name }}</div>
					<div class="box-nav-time" v-show="type == 2">
						{{ notic.createtime }}
					</div>
				</div>
				<div class="search-box-body">
					<div v-html="notic.content"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { $getDetail } from '@/api/index';
	export default {
		name: 'helpDetails',
		data() {
			return {
				notic: {},
				title: '',
				type: null,
			};
		},
		created() {
			let { id, type, title } = this.$route.query;
			let data;
			if (type) {
				data = {
					type,
					id,
				};
			} else {
				data = {
					id,
				};
			}
			this.getDetail(data);
			this.title = title;
			this.type = type;
		},
		methods: {
			getDetail(data) {
				$getDetail(data)
					.then((response) => {
						this.notic = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.wrap-container {
		position: relative;
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
		background-color: #f5f5f5;

		.bread {
			margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
			margin-left: 10%;
		}
		.search-box {
			width: 65%;
			margin-left: 17%;
			background-color: #fff;
			background-color: #fff;
			.search-box-nav {
				//   display: flex;
				//   justify-content: center;
				border-bottom: 1px solid #eee;
				padding: 35px;
				margin: 0 65px;
				text-align: center;
				.box-nav-title {
					font-size: 20px;

					font-weight: bold;
					margin-top: 5px;
					color: #333333;
				}
				.box-nav-time {
					margin-top: 16px;
					font-size: 16px;

					font-weight: 400;
					color: #999999;
				}
			}

			.search-box-body {
				padding: 40px 65px;
				// height: 500px;
				min-height: 650px;
				margin-bottom: 31px;
				// overflow-y: scroll;
				// overflow: auto;
				::v-deep {
					video,
					img {
						width: 100%;
						height: auto;
					}
				}
			}
			.box-body-item {
				border-bottom: 1px solid #eeee;
				padding-bottom: 15px;
				margin-bottom: 35px;
				.body-item-title {
					font-size: 18px;

					font-weight: bold;
					color: #e60000;
				}
				.body-item-info {
					font-size: 16px;

					font-weight: 400;
					color: #333333;
					margin-top: 10px;
				}
			}
		}
	}
	::v-deep {
		.el-tabs__nav-wrap::after {
			background-color: transparent !important;
			text-align: center;
		}

		.el-tabs__item {
			padding: 0 calc(var(--proportion) * 40px);
			font-size: 0.53rem;
			font-family: Alibaba PuHuiTi 2;
			font-weight: normal;
			color: #000 !important;
		}

		.el-tabs__active-bar {
			bottom: 2px;
			height: 8px;
			background: #e60000;
		}

		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}
	}
</style>
